module.exports = __webpack_public_path__ + "img/tune.3ac13962.svg";